// ABOUTME: Resolution helper for TabView3's pinned-views mode — turns a saved pin set
// ABOUTME: into the tabs to render, applying the first-run default and canonical ordering.

// How many tabs a first-time user starts with. Only a default — there is no
// maximum; how many tabs fit is the user's own call.
export const DEFAULT_PINNED_COUNT = 7;

/**
 * Resolve which view keys are pinned for a screen.
 *
 * @param savedKeys  pinnedKeys from userLayout.document.tabConfigs[tabKey], or null/undefined
 *                   when the user never saved a pin set.
 * @param allKeys    every view key of the screen, in canonical config order.
 * @returns          pinned keys in canonical order. No saved set → the first
 *                   DEFAULT_PINNED_COUNT keys. An explicitly empty saved set stays empty.
 */
export const resolvePinnedKeys = (savedKeys, allKeys) => {
    if (!Array.isArray(savedKeys)) {
        return allKeys.slice(0, DEFAULT_PINNED_COUNT);
    }
    return allKeys.filter((key) => savedKeys.includes(key));
};
